import React, { useState, useEffect } from "react"

import { secondsToHms } from "../../util/Utility"
import i18n from "../../i18n"

export function Card({
  title,
  time,
  itemId,
  src,
  alt,
  horizontalScrollCard,
  scrollTitleColor,
  onClick,
  isActiveOffer,
}) {
  const [offerTime, setOfferTime] = useState(+time)

  useEffect(
    () => {
      const offerTimer = setInterval(() => {
        setOfferTime(offerTime - 1)
      }, 1000)
      return () => {
        clearInterval(offerTimer)
      }
    },
    [offerTime]
  )

  //console.log("offertime", secondsToHms(offerTime))

  return (
    <div
      role='button'
      style={{
        border: "none",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        margin: "0 10px",
        width: horizontalScrollCard ? "260px" : "auto",
        height: horizontalScrollCard ? "200px" : "auto",
        userSelect: "none",
        borderRadius: "8px",
        backgroundColor: "#383d5a",
        padding: 0,
        cursor: "pointer",
      }}
      tabIndex={0}
      className='card'
      onClick={isActiveOffer === "true" ? onClick : null}
    >
      <div
        style={{
          padding: "5px",
          paddingBottom: 0,
          width: "100%",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            width: "100%",
            background: "#fff",
            borderRadius: "6px",
            borderBottomLeftRadius: 0,
            borderBottomRightRadius: 0,
          }}
        >
          <img
            src={src}
            alt={alt}
            style={{
              width: "100%",
              height: horizontalScrollCard ? "142px" : "auto",
              maxHeight: horizontalScrollCard ? "142px" : "240px",
              // objectFit: horizontalScrollCard ? "none" : "contain",
              objectFit: "contain",
            }}
          />
        </div>
      </div>
      <div
        style={{
          backgroundColor: scrollTitleColor,
          height: "53px",
          width: horizontalScrollCard ? "260px" : "100%",
          borderBottomLeftRadius: "8px",
          borderBottomRightRadius: "8px",
          margin: "-4px",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          padding: "10px",
          boxSizing: "border-box",
        }}
      >
        <p
          style={{
            fontFamily: "montserratRegular",
            fontSize: "15px",
            fontWeight: 500,
            color: "#000",
            marginLeft: "3px",
          }}
        >
          {title}
        </p>
        <span
          style={{
            width: "97px",
            height: "32px",
            borderRadius: "16px",
            backgroundColor: "#fff",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            color: "#2d2d2d",
            fontSize: "15px",
            fontFamily: "montserratRegular",
          }}
        >
          {isActiveOffer === "true"
            ? secondsToHms(offerTime)
            : i18n.t("Expired")}
        </span>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/horizontalScroll/Card.js